<div class="flex flex-col gap-8 px-4 pt-[10px]">
   <div class="flex gap-7">
      <div class="flex flex-col gap-1 flex-1">
         @if (acronymFC?.disabled) {
            <div class="flex flex-col gap-[10px]">
               <span class="ep-running-d-title">{{ 'project_acronym' | translate }}</span>
               <span class="ep-running-d-description">{{ acronymFC?.value ?? '-' }}</span>
            </div>
         } @else {
            <app-basic-input
               [id]="'ep-running-acronym-input'"
               [maxLength]="100"
               [required]="true"
               [inputFC]="acronymFC"
               [label]="'project_acronym' | translate"
            >
            </app-basic-input>
            @if (acronymFC?.touched && acronymFC?.invalid) {
               <span class="input-error-message">{{ getErrorMessage(acronymFC) | translate }}</span>
            }
         }
      </div>

      <div class="basic-column-divider"></div>

      <div class="flex flex-col gap-1 flex-1">
         @if (typeOfActionFC?.disabled) {
            <div class="flex flex-col gap-[10px]">
               <span class="ep-running-d-title">{{ 'type_of_action' | translate }}</span>
               <span class="ep-running-d-description">{{ typeOfActionFC?.value ? getLabelFromTypeOfActionId(typeOfActionFC?.value) : '-' }}</span>
            </div>
         } @else {
            <app-basic-dropdown
               [id]="'ep-running-type-of-action-select'"
               [required]="true"
               [optionValue]="'id'"
               [optionLabel]="'name'"
               [dropdownFC]="typeOfActionFC"
               [options]="typeOfActionArray"
               [label]="'type_of_action' | translate"
            ></app-basic-dropdown>
            @if (typeOfActionFC?.touched && typeOfActionFC?.invalid) {
               <span class="input-error-message">{{ getErrorMessage(typeOfActionFC) | translate }}</span>
            }
         }
      </div>

      <div class="basic-column-divider"></div>

      <div class="flex flex-col gap-1 flex-1">
         <div class="flex flex-col gap-[10px]">
            <span class="ep-running-d-title">{{ 'funding_associated' | translate }}</span>
            <span class="ep-running-d-description">{{ fundingAssociatedNameFC?.value ?? '-' }}</span>
         </div>
      </div>

      <div class="basic-column-divider"></div>

      <div class="flex flex-col gap-1 flex-1">
         <div class="flex flex-col gap-[10px]">
            <span class="ep-running-d-title">Current month</span>
            <span class="ep-running-d-description">{{ currentMonthFC?.value ?? '-' }}</span>
         </div>
      </div>

      <div class="basic-column-divider"></div>

      <div class="flex flex-col gap-1 flex-1">
         <div class="flex flex-col gap-[10px]">
            <span class="ep-running-d-title">{{ 'end_date' | translate }}</span>
            <span class="ep-running-d-description">{{ endDateFC?.value ? (endDateFC?.value | date: 'dd/MM/YYYY') : '-' }}</span>
         </div>
      </div>
   </div>

   <div class="basic-row-divider"></div>

   <div class="flex gap-5">
      <div class="flex gap-5 flex-1">
         <div class="flex-1 flex flex-col gap-1">
            <app-basic-calendar
               [id]="'edit-start-date-input'"
               [required]="true"
               [calendarFC]="startDateFC"
               [label]="'start_date' | translate"
            ></app-basic-calendar>
            @if (startDateFC?.touched && startDateFC?.invalid) {
               <span class="input-error-message">{{ getErrorMessage(startDateFC) | translate }}</span>
            }
         </div>
         <div class="flex flex-col gap-1 flex-1">
            <app-basic-input
               [id]="'ep-running-duration-input'"
               [maxLength]="120"
               [type]="'number'"
               [required]="true"
               [inputFC]="durationFC"
               [label]="'duration_months' | translate"
            >
            </app-basic-input>
            @if (durationFC?.touched && durationFC?.invalid) {
               <span class="input-error-message">{{
                  durationFC?.hasError('pattern')
                     ? ('error_input_onlyNumbers' | translate)
                     : durationFC?.hasError('max')
                       ? 'Max value is 180'
                       : (getErrorMessage(durationFC) | translate)
               }}</span>
            }
         </div>
      </div>

      <div class="flex-1 flex gap-5">
         <div class="flex flex-col gap-1 flex-1">
            <app-basic-input
               [id]="'edit-funding-agreement-input'"
               [type]="'number'"
               [maxLength]="999999999"
               [inputFC]="fundingAgreementIdFC"
               [label]="'funding_agreement_ID' | translate"
            >
            </app-basic-input>
            @if (fundingAgreementIdFC?.touched && fundingAgreementIdFC?.invalid) {
               <span class="input-error-message">{{ getErrorMessage(fundingAgreementIdFC) | translate }}</span>
            }
         </div>
         <app-basic-slider
            class="flex-1"
            [id]="'ep-running-funding-rate-input'"
            [sliderFC]="foundingFC"
            [label]="'funding_rate_for_action' | translate"
         ></app-basic-slider>
      </div>
   </div>
   <div class="flex gap-8">
      <div class="flex flex-col gap-1 flex-1 min-w-0">
         <label class="text-[13px]">{{ 'general_objectives' | translate }}</label>
         <app-basic-editor
            [id]="'ep-running-general-objectives-editor'"
            [scrollable]="true"
            [editorFC]="generalObjectivesFC"
         >
         </app-basic-editor>
      </div>
      <div class="flex flex-col gap-1 flex-1 min-w-0">
         <label class="text-[13px]">{{ 'additional_info' | translate }}</label>
         <app-basic-editor
            [id]="'ep-running-call-information-editor'"
            [scrollable]="true"
            [editorFC]="callOfTheProposalFC"
         >
         </app-basic-editor>
         @if (callOfTheProposalFC?.touched && callOfTheProposalFC?.invalid) {
            <span class="input-error-message">{{ getErrorMessage(callOfTheProposalFC) | translate }} 2048</span>
         }
      </div>
   </div>
</div>
